/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Stripe_Secret_KeyInputs */

const en_admin_settings_fields_stripe_secret_key = /** @type {(inputs: Admin_Settings_Fields_Stripe_Secret_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secret Key`)
};

/**
* | output |
* | --- |
* | "Secret Key" |
*
* @param {Admin_Settings_Fields_Stripe_Secret_KeyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_stripe_secret_key = /** @type {((inputs?: Admin_Settings_Fields_Stripe_Secret_KeyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Stripe_Secret_KeyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_fields_stripe_secret_key(inputs)
});
export { admin_settings_fields_stripe_secret_key as "admin.settings.fields.stripe_secret_key" }